import { useEffect, useState } from 'react';
import { startCapture } from 'components/newIdentifyMethods/VideoScreen/VideoScreenDispatcher/VideoSelfie/utils/requests/startCapture';

export const useStartCapture = (params, onError) => {
    const [{ accessToken, documentType }, setAccessData] = useState({ accessToken: null, documentType: null });

    useEffect(() => {
        void startCapture(params, { onError, onComplete: setAccessData });
    }, []);

    return { accessToken, documentType };
};
